import { useState, useCallback } from "react";
import { cn } from "@/lib/utils";

interface SmoothImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  placeholderClassName?: string;
  onLoad?: () => void;
}

export const SmoothImage = ({
  src,
  alt,
  width,
  height,
  className,
  placeholderClassName,
  onLoad: externalOnLoad,
}: SmoothImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
    externalOnLoad?.();
  }, [externalOnLoad]);

  return (
    <div className="relative">
      {/* Placeholder/skeleton while loading - matches image size */}
      <div
        className={cn(
          "absolute inset-0 bg-gradient-to-br from-gold/20 via-secondary/10 to-primary/15 rounded-lg",
          "transition-opacity duration-700 ease-out",
          isLoaded ? "opacity-0 pointer-events-none" : "opacity-100",
          placeholderClassName
        )}
      >
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse rounded-lg" />
      </div>
      
      {/* Actual image */}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        onLoad={handleLoad}
        className={cn(
          "transition-opacity duration-700 ease-out",
          isLoaded ? "opacity-100" : "opacity-0",
          className
        )}
      />
    </div>
  );
};